import { Box, styled } from 'decentraland-ui2';
const NavbarContainer = styled(Box)({
    paddingTop: '66px',
    width: '100%'
});
export { NavbarContainer };
//# sourceMappingURL=Navbar2.styled.js.map